import React from 'react';

import { FormattedMessage } from 'react-intl';

import { featureFlags } from '@modules/featureFlags/utils/featureFlags';
import { Card, Tabs } from '@shared/components';

import MbcMessage from '../MbcMessage';

const { TabPane } = Tabs;

export const MbcMessagingPage = () => (
  <Card margin noPadding shadow>
    <Tabs size="small">
      <TabPane
        key="new-message"
        tab={<FormattedMessage id="messaging.MbcMessagingPage.newMessage" />}
      >
        <MbcMessage />
      </TabPane>
    </Tabs>
  </Card>
);

export function MbcMessagingPageContainer() {
  const showMbcMessaging = featureFlags.getFlag('SBL_4409_SHOW_MBC_MESSAGING');
  if (!showMbcMessaging) return null;

  return <MbcMessagingPage />;
}

export default MbcMessagingPageContainer;
